export const catalogTabpanelStyles = () => ({
  root: { background: "background.paper", flex: 1 },
  inputSearch: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: 2,
  },
  searchField: {
    minWidth: "420px",
    marginBottom: "12px",
  },
  actions: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
    marginBottom: "12px",
  },
  manualHeader: {
    height: 40,
    color: "text.secondary",
    fontSize: 20,
  },
  manualFooter: {
    bottom: 0,
    height: 70,
    fontWeight: 600,
    padding: { p: [2, 1] },
    borderTop: "1px solid #d9d9d9",
  },
});
